import { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { showReview } from 'services/api/reviews';

export function useReviewPolling(reviewId: string, queryKeys: any, queryParams: any) {
  const [shouldPoll, setShouldPoll] = useState(false);
  const [allowRefetch, setAllowRefetch] = useState(false);

  const {
    data: review,
    isPending,
    isRefetching,
  } = useQuery({
    queryKey: queryKeys.show({ id: reviewId }),
    queryFn: () => showReview(queryParams.show(reviewId)),
    enabled: !!reviewId,
    refetchInterval: shouldPoll ? 2000 : false,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: shouldPoll,
  });

  useEffect(() => {
    const hasPendingJobs = review?.attachments?.some((attachment) => attachment.extractDataAIJob?.isPending) ?? false;
    setShouldPoll(hasPendingJobs && allowRefetch);
  }, [allowRefetch, review]);

  return {
    review,
    loading: isPending || (isRefetching && !shouldPoll),
    setAllowRefetch,
  };
}
